import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LocaleSelector.css';

const LOCALES = [
  { code: 'en', label: 'EN', full: 'English',  flag: '🇬🇧' },
  { code: 'fr', label: 'FR', full: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'DE', full: 'Deutsch',  flag: '🇩🇪' },
];

export default function LocaleSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'en';
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const active = LOCALES.find(l => l.code === current) || LOCALES[0];

  return (
    <div ref={ref} className="locale-selector">
      <button
        className="locale-trigger"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Change language"
      >
        <span className="locale-flag">{active.flag}</span>
        <span className="locale-label">{active.label}</span>
        <span className="locale-chevron">{open ? '▴' : '▾'}</span>
      </button>

      {open && (
        <div className="locale-dropdown" role="listbox">
          {LOCALES.map(({ code, label, full, flag }) => (
            <button
              key={code}
              role="option"
              aria-selected={code === current}
              className={`locale-option${code === current ? ' active' : ''}`}
              onClick={() => { i18n.changeLanguage(code); setOpen(false); }}
            >
              <span className="locale-flag">{flag}</span>
              <span className="locale-option-label">{label}</span>
              <span className="locale-option-full">{full}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
